<script setup lang="ts">
const { userEmail } = useUserData();

const userHasEmail = computed(() => {
  return userEmail.value;
});
</script>

<template>
  <div :class="$style.worldlineInfo">
    <div
      v-if="userHasEmail"
      :class="$style.myEmail"
    >
      {{ $t('withdraw.worldline.my_email') }}
      <strong>
        {{ userEmail }}
      </strong>
    </div>

    <div
      v-else
      class="alert alert-error"
      v-html="$t('withdraw.worldline.email_alert')"
    >
    </div>

    <div
      :class="$style.methodAlert"
      v-html="$t('withdraw.worldline.email_alert')"
    >
    </div>
  </div>
</template>

<style module lang="scss">
.worldlineInfo {
  .myEmail {
    @apply text-auth-texts flex items-center gap-x-2 text-base flex-wrap gap-y-0 leading-6;
  }
  .methodAlert {
    @apply text-warning text-xs mt-3;
  }
}
</style>
